import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, money, errMsg } from "../lib/api";
import { PageHeader, Loading } from "../components/PageHeader";

export default function Orders() {
  const [orders, setOrders] = useState(null);
  useEffect(() => {
    api.get("/orders").then((r) => setOrders(r.data)).catch((e) => { setOrders([]); toast.error(errMsg(e)); });
  }, []);
  return (
    <div data-testid="orders-page">
      <PageHeader eyebrow="Account" title="Order history" />
      <div className="wb-container">
        {!orders ? <Loading /> : orders.length === 0 ? <p className="muted" data-testid="orders-empty">No orders yet.</p> : (
          <div className="border-t wb-line">
            {orders.map((o) => (
              <Link key={o.id} to={`/order/${o.id}`} className="group grid grid-cols-2 gap-4 border-b wb-line py-6 md:grid-cols-5 md:items-center" data-testid={`order-row-${o.order_number}`}>
                <span className="font-display text-xl group-hover:text-wb-gold transition-colors">{o.order_number}</span>
                <span className="font-mono text-xs muted">{new Date(o.created_at).toLocaleDateString()}</span>
                <span className="text-sm muted md:col-span-1">{o.items.length} item{o.items.length > 1 && "s"}</span>
                <span className="font-mono text-xs uppercase tracking-widest gold">{o.status}</span>
                <span className="font-mono text-right">{money(o.amount_paid ?? o.total)}</span>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
